import React, { useState } from 'react';
import styled from 'styled-components';
import {
    EuiFlyout,
    EuiFlyoutBody,
    EuiFlyoutHeader,
    EuiTitle,
    EuiIcon
} from '@elastic/eui';
import utilsService from '../../../../../servises/utils.service';
import FillBar from '../../../../components/metrics/FillBar';
import TotalVerticalInfo from '../../../../components/metrics/TotalVerticalInfo';

const ShowDrilldownStyled = styled.div`
  color: #1890ff;
  cursor: pointer;
  font-size: 14px;
  display: inline-flex;
  align-items: center;
  gap: 3px;
  line-height: 16px;

  &:hover {
    text-decoration: underline;
  }

  svg {
    path {
      fill: #1890ff;
    }
  }
`;


const ContentGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 16px;
  margin-top: 10px;
  
  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

const SectionHeader = styled.div`
  grid-column: span 2;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  color: var(--color-primary, #6366f1);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  padding-bottom: 6px;
  margin-top: 14px;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  gap: 6px;
  
  @media (max-width: 600px) {
    grid-column: span 1;
  }
`;

const StorageSection = styled.div`
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.04);
  border-radius: 8px;
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  
  .header-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    
    .label-group {
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: 11px;
      color: rgba(255, 255, 255, 0.45);
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      
      .icon {
        color: ${props => props.color || 'rgb(0, 128, 213)'};
        opacity: 0.8;
      }
    }
    
    .value-pct {
      font-size: 14px;
      font-weight: 800;
      color: #fff;
      font-family: Consolas, monospace;
    }
  }
  
  .details-bar {
    margin: 4px 0;
    
    & > div {
      margin: 0;
    }
  }
`;

const DisksListStyled = styled.section`
  grid-column: span 2;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(110px, 1fr));
  grid-gap: 12px;
  margin-top: 6px;
  
  @media (max-width: 600px) {
    grid-column: span 1;
  }
`;

const DiskIoRow = styled.div`
  grid-column: span 2;
  display: grid;
  grid-template-columns: 1fr 2fr;
  align-items: center;
  background: rgba(255, 255, 255, 0.01);
  border: 1px solid rgba(255, 255, 255, 0.03);
  border-radius: 8px;
  padding: 12px 14px;
  
  @media (max-width: 600px) {
    grid-column: span 1;
    grid-template-columns: 1fr;
    gap: 12px;
  }
  
  .disk-name-col {
    display: flex;
    flex-direction: column;
    gap: 6px;
    
    .name-wrapper {
      display: flex;
      align-items: center;
      gap: 8px;
      font-weight: 700;
      color: #fff;
      font-size: 14px;
    }
    
    .busy-badge {
      font-size: 9px;
      padding: 2px 6px;
      border-radius: 4px;
      font-family: Consolas, monospace;
      font-weight: 600;
      width: fit-content;
      background: ${props => props.busyBg || 'rgba(255, 255, 255, 0.05)'};
      color: ${props => props.busyColor || '#fff'};
    }
  }

  .stats-col {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 12px;
    font-size: 12px;
    
    .stat-pair {
      display: flex;
      flex-direction: column;
      
      .stat-lbl {
        color: rgba(255, 255, 255, 0.45);
        font-size: 9px;
        text-transform: uppercase;
        font-weight: 600;
        letter-spacing: 0.3px;
      }
      
      .stat-val {
        color: #fff;
        font-family: Consolas, monospace;
        font-weight: 700;
        margin-top: 1px;
      }
    }
  }
`;

const RaidCard = styled.div`
  grid-column: span 2;
  display: flex;
  flex-direction: column;
  gap: 8px;
  background: rgba(255, 255, 255, 0.01);
  border: 1px solid rgba(255, 255, 255, 0.03);
  border-radius: 8px;
  padding: 12px 14px;
  
  @media (max-width: 600px) {
    grid-column: span 1;
  }
  
  .raid-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    
    .raid-title {
      display: flex;
      align-items: center;
      gap: 8px;
      font-weight: 700;
      color: #fff;
      font-size: 14px;
    }
  }
  
  .raid-stats {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
    grid-gap: 12px;
    font-size: 12px;
    margin-top: 4px;
    border-top: 1px solid rgba(255, 255, 255, 0.04);
    padding-top: 10px;
    
    .stat-pair {
      display: flex;
      flex-direction: column;
      gap: 2px;
      
      .lbl {
        color: rgba(255, 255, 255, 0.45);
        font-size: 9px;
        text-transform: uppercase;
        font-weight: 600;
      }
      .val {
        color: #fff;
        font-family: Consolas, monospace;
        font-weight: 700;
      }
    }
  }
`;

const StatusBadge = styled.span`
  font-size: 9px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 2px 6px;
  border-radius: 4px;
  background: ${props => props.bg || 'rgba(255, 255, 255, 0.05)'};
  color: ${props => props.color || '#fff'};
`;

const getBusyColor = busy => {
    if (busy > 85) return { bg: 'rgba(244, 63, 94, 0.15)', text: '#f43f5e' };
    if (busy > 50) return { bg: 'rgba(245, 158, 11, 0.15)', text: '#f59e0b' };
    return { bg: 'rgba(16, 185, 129, 0.15)', text: '#10b981' };
};

const getRaidStatusStyle = status => {
    const s = (status || "").toLowerCase();
    if (s.includes("clean") || s.includes("active") || s.includes("ok") || s.includes("optimum")) {
        return { bg: 'rgba(16, 185, 129, 0.15)', color: '#10b981' };
    }
    if (s.includes("degraded") || s.includes("rebuild") || s.includes("recover")) {
        return { bg: 'rgba(245, 158, 11, 0.15)', color: '#f59e0b' };
    }
    return { bg: 'rgba(244, 63, 94, 0.15)', color: '#f43f5e' };
};

function generateDisks(server) {
    let disks = [];

    if (server && server.metrics && server.metrics[0]) {
        const metrics = server.metrics[0];
        const disksList = metrics.disk_list;

        if (disksList && disksList.length > 0) {
            disks = disksList.map(pd => {
                const total = utilsService.formatBytes(pd.total);
                const used = utilsService.formatBytes(pd.used);

                return ({
                    name: pd.name,
                    total: pd.total,
                    totalData: total.value,
                    totalUnit: total.unit,
                    used: pd.used,
                    usedData: used.value,
                    usedUnit: used.unit
                });
            });
        }
    }

    disks.sort((a, b) => b.total - a.total);

    return disks;
}

const DiskDrilldown = ({ server }) => {
    const [showFlyout, setShowFlyout] = useState(false);

    const diskTotal = utilsService.getFromMetrics(server, "disk_total");
    const diskUsage = utilsService.getFromMetrics(server, "disk_usage");

    const swapTotal = utilsService.getFromMetrics(server, "swap_total");
    const swapUsage = utilsService.getFromMetrics(server, "swap_usage");

    const disksData = generateDisks(server);

    const diskPct = utilsService.getPercent(diskUsage, diskTotal) || 0;
    const swapPct = utilsService.getPercent(swapUsage, swapTotal) || 0;

    const diskIo = utilsService.getFromMetrics(server, "disk_io", null);
    const raidDetails = utilsService.getFromMetrics(server, "raid_details", null);

    return (
        <>
            <ShowDrilldownStyled onClick={ () => setShowFlyout(true) }>
                Details
                <EuiIcon type="inspect" size="s" style={{ alignSelf: 'center' }} />
            </ShowDrilldownStyled>

            { showFlyout && (
                <EuiFlyout
                    size="l"
                    ownFocus={true}
                    outsideClickCloses={true}
                    onClose={ () => setShowFlyout(false) }
                >
                    <EuiFlyoutHeader hasBorder>
                        <EuiTitle size="m">
                            <h2>Storage & Partition Dashboard</h2>
                        </EuiTitle>
                    </EuiFlyoutHeader>
                    <EuiFlyoutBody>
                        <ContentGrid>
                            <SectionHeader>
                                <EuiIcon type="storage" size="s" /> Storage Summary
                            </SectionHeader>
                            {/* Total Disk space */}
                            <StorageSection color="#ed8936">
                                <div className="header-row">
                                    <div className="label-group">
                                        <EuiIcon type="storage" size="s" className="icon" />
                                        <span>Total Storage</span>
                                    </div>
                                    <span className="value-pct">{ diskPct }%</span>
                                </div>
                                <div className="details-bar">
                                    <FillBar
                                        total={ server.serverData.diskDataTotal.value }
                                        totalUnit={ server.serverData.diskDataTotal.unit }
                                        current={ server.serverData.diskDataCurrent.value }
                                        currentUnit={ server.serverData.diskDataCurrent.unit }
                                        originalTotal={ diskTotal }
                                        originalCurrent={ diskUsage }
                                    />
                                </div>
                            </StorageSection>

                            {/* Swap Space */}
                            <StorageSection color="#f9be49">
                                <div className="header-row">
                                    <div className="label-group">
                                        <EuiIcon type="storage" size="s" className="icon" />
                                        <span>Swap Space</span>
                                    </div>
                                    <span className="value-pct">{ swapPct }%</span>
                                </div>
                                <div className="details-bar">
                                    <FillBar
                                        total={ server.serverData.swapDataTotal.value }
                                        totalUnit={ server.serverData.swapDataTotal.unit }
                                        current={ server.serverData.swapDataCurrent.value }
                                        currentUnit={ server.serverData.swapDataCurrent.unit }
                                        originalTotal={ swapTotal }
                                        originalCurrent={ swapUsage }
                                    />
                                </div>
                            </StorageSection>

                            {/* Partition list */}
                            { disksData.length > 0 && (
                                <>
                                    <SectionHeader>
                                        <EuiIcon type="storage" size="s" /> Partition Drives ({ disksData.length })
                                    </SectionHeader>
                                    <DisksListStyled>
                                        { disksData.map((item, idx) => {
                                            if (item.name) {
                                                return (
                                                    <div key={ idx + "d21dz" } style={{ background: 'rgba(255,255,255,0.01)', border: '1px solid rgba(255,255,255,0.03)', borderRadius: '8px', padding: '12px 10px', display: 'flex', justifyContent: 'center' }}>
                                                        <TotalVerticalInfo
                                                            title={ item.name }
                                                            start={ 0 }
                                                            current={ item.usedData }
                                                            total={ item.totalData }
                                                            currentOriginal={ item.used }
                                                            totalOriginal={ item.total }
                                                            totaExt={ item.totalUnit }
                                                            currentExt={ item.usedUnit }
                                                        />
                                                    </div>
                                                );
                                            } else {
                                                return null;
                                            }
                                        }) }
                                    </DisksListStyled>
                                </>
                            ) }

                            {/* Disk IO */}
                            { diskIo && diskIo.length > 0 && (
                                <>
                                    <SectionHeader>
                                        <EuiIcon type="visMapCoordinate" size="s" /> Disk I/O Real-time Performance
                                    </SectionHeader>
                                    { diskIo.map((io, idx) => {
                                        const rSpeed = utilsService.formatBytes(io.read_bytes_per_sec || 0);
                                        const wSpeed = utilsService.formatBytes(io.write_bytes_per_sec || 0);
                                        const rTotal = utilsService.formatBytes(io.total_read_bytes || 0);
                                        const wTotal = utilsService.formatBytes(io.total_write_bytes || 0);
                                        const busyColor = getBusyColor(io.busy_percent || 0);

                                        return (
                                            <DiskIoRow key={idx + "dio"} busyBg={busyColor.bg} busyColor={busyColor.text}>
                                                <div className="disk-name-col">
                                                    <div className="name-wrapper">
                                                        <EuiIcon type="storage" size="s" />
                                                        <span>{io.name}</span>
                                                    </div>
                                                    {io.busy_percent !== undefined && (
                                                        <span className="busy-badge">{io.busy_percent.toFixed(1)}% busy</span>
                                                    )}
                                                </div>
                                                <div className="stats-col">
                                                    <div className="stat-pair">
                                                        <span className="stat-lbl">Read Transfer</span>
                                                        <span className="stat-val">{rSpeed.value} {rSpeed.unit}/s</span>
                                                        {io.read_iops !== undefined && (
                                                            <span style={{ fontSize: '9px', color: 'rgba(255,255,255,0.4)', fontFamily: 'Consolas, monospace' }}>
                                                                {io.read_iops.toFixed(0)} IOPS
                                                            </span>
                                                        )}
                                                    </div>
                                                    <div className="stat-pair">
                                                        <span className="stat-lbl">Write Transfer</span>
                                                        <span className="stat-val">{wSpeed.value} {wSpeed.unit}/s</span>
                                                        {io.write_iops !== undefined && (
                                                            <span style={{ fontSize: '9px', color: 'rgba(255,255,255,0.4)', fontFamily: 'Consolas, monospace' }}>
                                                                {io.write_iops.toFixed(0)} IOPS
                                                            </span>
                                                        )}
                                                    </div>
                                                    <div className="stat-pair" style={{ gridColumn: 'span 2', marginTop: '4px', borderTop: '1px solid rgba(255,255,255,0.03)', paddingTop: '4px' }}>
                                                        <span className="stat-lbl">Total I/O Data transferred</span>
                                                        <span className="stat-val" style={{ fontSize: '11px' }}>
                                                            R: {rTotal.value} {rTotal.unit} / W: {wTotal.value} {wTotal.unit}
                                                        </span>
                                                    </div>
                                                </div>
                                            </DiskIoRow>
                                        );
                                    }) }
                                </>
                            ) }

                            {/* RAID Arrays */}
                            { raidDetails && raidDetails.length > 0 && (
                                <>
                                    <SectionHeader>
                                        <EuiIcon type="package" size="s" /> RAID Configurations & Arrays
                                    </SectionHeader>
                                    { raidDetails.map((raid, idx) => {
                                        const badgeStyle = getRaidStatusStyle(raid.status || "");
                                        return (
                                            <RaidCard key={idx + "raid"}>
                                                <div className="raid-header">
                                                    <div className="raid-title">
                                                        <EuiIcon type="package" size="s" />
                                                        <span>{raid.name}</span>
                                                    </div>
                                                    <StatusBadge bg={badgeStyle.bg} color={badgeStyle.color}>
                                                        {raid.status || "Unknown"}
                                                    </StatusBadge>
                                                </div>
                                                <div className="raid-stats">
                                                    { raid.level && (
                                                        <div className="stat-pair">
                                                            <span className="lbl">Level</span>
                                                            <span className="val">{raid.level}</span>
                                                        </div>
                                                    ) }
                                                    { raid.type && (
                                                        <div className="stat-pair">
                                                            <span className="lbl">Type</span>
                                                            <span className="val">{raid.type}</span>
                                                        </div>
                                                    ) }
                                                    <div className="stat-pair">
                                                        <span className="lbl">Active Disks</span>
                                                        <span className="val">{raid.active_devices} / {raid.total_devices}</span>
                                                    </div>
                                                    { raid.failed_devices > 0 && (
                                                        <div className="stat-pair">
                                                            <span className="lbl" style={{ color: 'var(--color-danger, #f43f5e)' }}>Failed Disks</span>
                                                            <span className="val" style={{ color: 'var(--color-danger, #f43f5e)' }}>{raid.failed_devices}</span>
                                                        </div>
                                                    ) }
                                                    { raid.spare_devices > 0 && (
                                                        <div className="stat-pair">
                                                            <span className="lbl">Spare Disks</span>
                                                            <span className="val">{raid.spare_devices}</span>
                                                        </div>
                                                    ) }
                                                </div>
                                            </RaidCard>
                                        );
                                    }) }
                                </>
                            ) }
                        </ContentGrid>
                    </EuiFlyoutBody>
                </EuiFlyout>
                ) }
        </>
    );
};

export default DiskDrilldown;
